import { put, takeLatest } from 'redux-saga/effects';
import { ApiResponse } from '../../api/request';
import {
  checkInAttendeeAction,
  checkInAttendeeErrorAction,
  checkInAttendeeSuccessAction,
  errorListAttendeesAction,
  getListAttendeesAction, getReservationAction,
  setListAttendeesAction,
  setReservationAction
} from '../../store/customers/list-attendees.store';
import { authenticatedCall } from '../../utils/authenticated-call';
import {
  attendeesCheckInAPI, attendeesListAPI, retrieveEventAPI
} from '../../api/provider/booking/booking-provider';

function* retrieveReservationSaga(data: any) {

  try {
    const reservationResponse: ApiResponse = yield authenticatedCall(retrieveEventAPI, data.payload);
    yield put(setReservationAction(reservationResponse.data.data))
  } catch (error: any) {
    yield put(errorListAttendeesAction(error.localizedMessage))
  }
}

function* getListAttendeesSaga(data: any) {

  try {
    const attendeesListResponse: ApiResponse | null = yield authenticatedCall(attendeesListAPI, data.payload);
    yield put(setListAttendeesAction(attendeesListResponse?.data.data))
  } catch (error: any) {
    yield put(errorListAttendeesAction(error.localizedMessage))
  }
}

function* checkInAttendeeSaga(data: any) {

  try {
    yield authenticatedCall(attendeesCheckInAPI, data.payload);
    yield put(checkInAttendeeSuccessAction(true))
  } catch (error: any) {
    yield put(checkInAttendeeErrorAction(error.localizedMessage))
  }
}

export function* listAttendeesSagas() {
  yield takeLatest(getListAttendeesAction.type, getListAttendeesSaga);
  yield takeLatest(checkInAttendeeAction.type, checkInAttendeeSaga);
  yield takeLatest(getReservationAction.type, retrieveReservationSaga);
}
